import { Box } from '@mui/material';
import { useState, useRef } from 'react';
import SweepSelect from '../common/SweepSelect';
import { getMetadataLabel } from '../documentation/tabs/getMetadataLabel';
import { MetadataSelectionPopover } from '../documentation/tabs/MetadataSelectionPopover';
import { MetadataTypeProperties } from '@server/documentation';

interface MetadataTypeSelectorProps {
  crmOrgId: string;
  value?: string;
  onChange?: (value: string) => void;
  fullWidth?: boolean;
}

export const MetadataTypeSelector = ({
  crmOrgId,
  value = '',
  onChange,
  fullWidth,
}: MetadataTypeSelectorProps) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const anchorRef = useRef<HTMLDivElement>(null);

  const handleSelectMetadata = (metadataType: MetadataTypeProperties) => {
    onChange?.(metadataType.name);
  };

  const displayValue = value ? getMetadataLabel(value) : '';

  return (
    <>
      <Box ref={anchorRef}>
        <SweepSelect
          children={<></>}
          SelectProps={{
            value: value,
            open: false,
            onOpen: () => setIsPopoverOpen(true),
            displayEmpty: true,
            placeholder: 'Choose a metadata type',
            renderValue: () => displayValue,
          }}
          FormControlProps={{
            fullWidth,
          }}
          onOpenCb={() => setIsPopoverOpen(true)}
        />
      </Box>

      <MetadataSelectionPopover
        isOpen={isPopoverOpen}
        onClose={() => setIsPopoverOpen(false)}
        anchorEl={anchorRef.current}
        onSelectMetadata={handleSelectMetadata}
        crmOrgId={crmOrgId}
      />
    </>
  );
};
